/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upsell__Get_PremiumInputs */

const en_upsell__get_premium = /** @type {(inputs: Upsell__Get_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Premium!`)
};

/**
* | output |
* | --- |
* | "Get Premium!" |
*
* @param {Upsell__Get_PremiumInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const upsell__get_premium = /** @type {((inputs?: Upsell__Get_PremiumInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upsell__Get_PremiumInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_upsell__get_premium(inputs)
});